/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type MediaAssetFileStatusKind = "AVAILABLE" | "CREATED" | "DELETED" | "ERROR" | "PROCESSING" | "%future added value";
export type MediaAssetStateKind = "AVAILABLE" | "CREATED" | "DELETED" | "PROCESSING" | "%future added value";
export type PreviewKind = "A_ROLE" | "BACKGROUND" | "BADGE_DARK" | "BADGE_LIGHT" | "B_ROLE" | "CAROUSEL" | "DETAIL_BACKGROUND" | "EXCERPT" | "HEADSHOT" | "HERO" | "HERO_LOGO" | "LOGO" | "PORTRAIT" | "SQUARE" | "%future added value";
export type TopLevelMediaKind = "APPLICATION" | "AUDIO" | "DOCUMENT" | "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type originalShowsQueryVariables = {
    readonly listCollectionId: string;
};
export type originalShowsQueryResponse = {
    readonly listCollection: {
        readonly errors: ReadonlyArray<{
            readonly created: unknown | null;
            readonly id: string;
            readonly location: string | null;
            readonly type: string | null;
        } | null> | null;
        readonly hasErrors: boolean | null;
        readonly listCollection: {
            readonly description: string | null;
            readonly id: string;
            readonly label: string | null;
            readonly revision: string | null;
            readonly lists: ReadonlyArray<{
                readonly __typename: "FixedList";
                readonly landingPageUrl?: string | null;
                readonly description?: string | null;
                readonly id?: string;
                readonly moreLikeThis?: string | null;
                readonly badges?: ReadonlyArray<{
                    readonly imageLink: string | null;
                    readonly link: string | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                }> | null;
                readonly items?: {
                    readonly pageInfo: {
                        readonly hasNextPage: boolean | null;
                    } | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly listItem: {
                            readonly item: ({
                                readonly __typename: string;
                                readonly id?: string;
                                readonly revision?: string | null;
                                readonly landingPageUrl?: string | null;
                                readonly sourceList?: string | null;
                                readonly durationInSeconds?: number | null;
                                readonly description?: string | null;
                                readonly externalId?: string | null;
                                readonly subTitle?: string | null;
                                readonly title?: string | null;
                                readonly label?: string | null;
                                readonly link?: string | null;
                                readonly previews?: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                                readonly actionDescription?: string | null;
                                readonly actionTitle?: string | null;
                                readonly permalink?: string | null;
                            } & ({
                                readonly __typename: "OriginalContentStory";
                                readonly id: string;
                                readonly revision: string | null;
                                readonly landingPageUrl: string | null;
                                readonly sourceList: string | null;
                                readonly durationInSeconds: number | null;
                                readonly description: string | null;
                                readonly externalId: string | null;
                                readonly subTitle: string | null;
                                readonly title: string | null;
                                readonly label: string | null;
                                readonly link: string | null;
                                readonly previews: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                            } | {
                                readonly __typename: "Poster";
                                readonly actionDescription: string | null;
                                readonly actionTitle: string | null;
                                readonly permalink: string | null;
                            } | {
                                /*This will never be '% other', but we need some
                                value in case none of the concrete values match.*/
                                readonly __typename: "%other";
                            })) | null;
                            readonly question: string | null;
                        } | null;
                    }> | null;
                } | null;
                readonly label?: string | null;
                readonly name?: string | null;
                readonly previews?: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly mediaAsset: {
                                readonly id: string;
                                readonly files: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly heightInPixels: number | null;
                                    readonly widthInPixels: number | null;
                                    readonly path: string | null;
                                    readonly status: {
                                        readonly kind: MediaAssetFileStatusKind | null;
                                    } | null;
                                }> | null;
                                readonly state: {
                                    readonly kind: MediaAssetStateKind | null;
                                } | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                } | null;
                            } | null;
                            readonly kind: PreviewKind | null;
                            readonly link: string | null;
                        } | null;
                    }> | null;
                } | null;
                readonly subTitle?: string | null;
                readonly title?: string | null;
            } & ({
                readonly __typename: "FixedList";
                readonly landingPageUrl: string | null;
                readonly description: string | null;
                readonly id: string;
                readonly moreLikeThis: string | null;
                readonly badges: ReadonlyArray<{
                    readonly imageLink: string | null;
                    readonly link: string | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                }> | null;
                readonly items: {
                    readonly pageInfo: {
                        readonly hasNextPage: boolean | null;
                    } | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly listItem: {
                            readonly item: ({
                                readonly __typename: string;
                                readonly id?: string;
                                readonly revision?: string | null;
                                readonly landingPageUrl?: string | null;
                                readonly sourceList?: string | null;
                                readonly durationInSeconds?: number | null;
                                readonly description?: string | null;
                                readonly externalId?: string | null;
                                readonly subTitle?: string | null;
                                readonly title?: string | null;
                                readonly label?: string | null;
                                readonly link?: string | null;
                                readonly previews?: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                                readonly actionDescription?: string | null;
                                readonly actionTitle?: string | null;
                                readonly permalink?: string | null;
                            } & ({
                                readonly __typename: "OriginalContentStory";
                                readonly id: string;
                                readonly revision: string | null;
                                readonly landingPageUrl: string | null;
                                readonly sourceList: string | null;
                                readonly durationInSeconds: number | null;
                                readonly description: string | null;
                                readonly externalId: string | null;
                                readonly subTitle: string | null;
                                readonly title: string | null;
                                readonly label: string | null;
                                readonly link: string | null;
                                readonly previews: {
                                    readonly count: number | null;
                                    readonly edges: ReadonlyArray<{
                                        readonly cursor: string | null;
                                        readonly preview: {
                                            readonly mediaAsset: {
                                                readonly id: string;
                                                readonly files: ReadonlyArray<{
                                                    readonly id: string;
                                                    readonly name: string | null;
                                                    readonly heightInPixels: number | null;
                                                    readonly widthInPixels: number | null;
                                                    readonly path: string | null;
                                                    readonly status: {
                                                        readonly kind: MediaAssetFileStatusKind | null;
                                                    } | null;
                                                }> | null;
                                                readonly state: {
                                                    readonly kind: MediaAssetStateKind | null;
                                                } | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                            readonly kind: PreviewKind | null;
                                            readonly link: string | null;
                                        } | null;
                                    }> | null;
                                } | null;
                            } | {
                                readonly __typename: "Poster";
                                readonly actionDescription: string | null;
                                readonly actionTitle: string | null;
                                readonly permalink: string | null;
                            } | {
                                /*This will never be '% other', but we need some
                                value in case none of the concrete values match.*/
                                readonly __typename: "%other";
                            })) | null;
                            readonly question: string | null;
                        } | null;
                    }> | null;
                } | null;
                readonly label: string | null;
                readonly name: string | null;
                readonly previews: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly mediaAsset: {
                                readonly id: string;
                                readonly files: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly heightInPixels: number | null;
                                    readonly widthInPixels: number | null;
                                    readonly path: string | null;
                                    readonly status: {
                                        readonly kind: MediaAssetFileStatusKind | null;
                                    } | null;
                                }> | null;
                                readonly state: {
                                    readonly kind: MediaAssetStateKind | null;
                                } | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                } | null;
                            } | null;
                            readonly kind: PreviewKind | null;
                            readonly link: string | null;
                        } | null;
                    }> | null;
                } | null;
                readonly subTitle: string | null;
                readonly title: string | null;
            } | {
                /*This will never be '% other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            })> | null;
            readonly name: string | null;
            readonly subTitle: string | null;
            readonly title: string | null;
        } | null;
    } | null;
};
export type originalShowsQuery = {
    readonly response: originalShowsQueryResponse;
    readonly variables: originalShowsQueryVariables;
};



/*
query originalShowsQuery(
  $listCollectionId: ID!
) {
  listCollection(id: $listCollectionId) {
    errors {
      created
      id
      location
      type
    }
    hasErrors
    listCollection {
      description
      id
      label
      revision
      lists {
        __typename
        ... on FixedList {
          __typename
          landingPageUrl
          description
          id
          moreLikeThis
          badges {
            imageLink
            link
            previews {
              count
              edges {
                cursor
                preview {
                  mediaAsset {
                    id
                    files {
                      id
                      name
                      heightInPixels
                      widthInPixels
                      path
                      status {
                        kind
                        id
                      }
                    }
                    state {
                      kind
                      id
                    }
                    topLevelMediaType {
                      kind
                      id
                    }
                  }
                  kind
                  link
                }
              }
            }
            id
          }
          items {
            pageInfo {
              hasNextPage
            }
            edges {
              cursor
              listItem {
                item {
                  __typename
                  ... on OriginalContentStory {
                    __typename
                    id
                    revision
                    landingPageUrl
                    sourceList
                    durationInSeconds
                    description
                    externalId
                    subTitle
                    title
                    label
                    link
                    previews {
                      count
                      edges {
                        cursor
                        preview {
                          mediaAsset {
                            id
                            files {
                              id
                              name
                              heightInPixels
                              widthInPixels
                              path
                              status {
                                kind
                                id
                              }
                            }
                            state {
                              kind
                              id
                            }
                            topLevelMediaType {
                              kind
                              id
                            }
                          }
                          kind
                          link
                        }
                      }
                    }
                  }
                  ... on Poster {
                    __typename
                    actionDescription
                    actionTitle
                    description
                    permalink
                    id
                    previews {
                      count
                      edges {
                        cursor
                        preview {
                          mediaAsset {
                            id
                            files {
                              id
                              name
                              heightInPixels
                              widthInPixels
                              path
                              status {
                                kind
                                id
                              }
                            }
                            state {
                              kind
                              id
                            }
                            topLevelMediaType {
                              kind
                              id
                            }
                          }
                          kind
                          link
                        }
                      }
                    }
                    subTitle
                    title
                    revision
                  }
                  ... on Node {
                    id
                  }
                  ... on SearchHit {
                    id
                  }
                  ... on Tag {
                    id
                  }
                }
                question
                id
              }
            }
          }
          label
          name
          previews {
            count
            edges {
              cursor
              preview {
                mediaAsset {
                  id
                  files {
                    id
                    name
                    heightInPixels
                    widthInPixels
                    path
                    status {
                      kind
                      id
                    }
                  }
                  state {
                    kind
                    id
                  }
                  topLevelMediaType {
                    kind
                    id
                  }
                }
                kind
                link
              }
            }
          }
          subTitle
          title
        }
        ... on Node {
          id
        }
      }
      name
      subTitle
      title
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "listCollectionId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "listCollectionId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "created",
      "args": null,
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revision",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "moreLikeThis",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageLink",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "heightInPixels",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "widthInPixels",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v14/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "files",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetFile",
                  "plural": true,
                  "selections": [
                    (v2/*: any*/),
                    (v15/*: any*/),
                    (v16/*: any*/),
                    (v17/*: any*/),
                    (v18/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "status",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MediaAssetFileStatus",
                      "plural": false,
                      "selections": (v20/*: any*/)
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "state",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetState",
                  "plural": false,
                  "selections": (v20/*: any*/)
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "topLevelMediaType",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TopLevelMediaType",
                  "plural": false,
                  "selections": (v20/*: any*/)
                }
              ]
            },
            (v19/*: any*/),
            (v12/*: any*/)
          ]
        }
      ]
    }
  ]
},
v22 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sourceList",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "durationInSeconds",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "externalId",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subTitle",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionDescription",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionTitle",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "permalink",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "question",
  "args": null,
  "storageKey": null
},
v32 = [
  (v19/*: any*/),
  (v2/*: any*/)
],
v33 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v14/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "files",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetFile",
                  "plural": true,
                  "selections": [
                    (v2/*: any*/),
                    (v15/*: any*/),
                    (v16/*: any*/),
                    (v17/*: any*/),
                    (v18/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "status",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MediaAssetFileStatus",
                      "plural": false,
                      "selections": (v32/*: any*/)
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "state",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetState",
                  "plural": false,
                  "selections": (v32/*: any*/)
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "topLevelMediaType",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TopLevelMediaType",
                  "plural": false,
                  "selections": (v32/*: any*/)
                }
              ]
            },
            (v19/*: any*/),
            (v12/*: any*/)
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "originalShowsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "listCollection",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListCollectionPayload",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "listCollection",
            "storageKey": null,
            "args": null,
            "concreteType": "ListCollection",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lists",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "type": "FixedList",
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v5/*: any*/),
                      (v2/*: any*/),
                      (v10/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "badges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Badge",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v21/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "items",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ListItemsConnection",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItemEdge",
                            "plural": true,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "listItem",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ListItem",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "item",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "type": "OriginalContentStory",
                                        "selections": [
                                          (v2/*: any*/),
                                          (v7/*: any*/),
                                          (v9/*: any*/),
                                          (v23/*: any*/),
                                          (v24/*: any*/),
                                          (v5/*: any*/),
                                          (v25/*: any*/),
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          (v6/*: any*/),
                                          (v12/*: any*/),
                                          (v21/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "Poster",
                                        "selections": [
                                          (v28/*: any*/),
                                          (v29/*: any*/),
                                          (v5/*: any*/),
                                          (v30/*: any*/),
                                          (v2/*: any*/),
                                          (v21/*: any*/),
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          (v7/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v31/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v6/*: any*/),
                      (v15/*: any*/),
                      (v21/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/)
                    ]
                  }
                ]
              },
              (v15/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "originalShowsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "listCollection",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListCollectionPayload",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "listCollection",
            "storageKey": null,
            "args": null,
            "concreteType": "ListCollection",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lists",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "type": "FixedList",
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v5/*: any*/),
                      (v10/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "badges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Badge",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v33/*: any*/),
                          (v2/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "items",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ListItemsConnection",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItemEdge",
                            "plural": true,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "listItem",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ListItem",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "item",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v2/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "type": "OriginalContentStory",
                                        "selections": [
                                          (v7/*: any*/),
                                          (v9/*: any*/),
                                          (v23/*: any*/),
                                          (v24/*: any*/),
                                          (v5/*: any*/),
                                          (v25/*: any*/),
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          (v6/*: any*/),
                                          (v12/*: any*/),
                                          (v33/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "Poster",
                                        "selections": [
                                          (v28/*: any*/),
                                          (v29/*: any*/),
                                          (v5/*: any*/),
                                          (v30/*: any*/),
                                          (v33/*: any*/),
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          (v7/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v31/*: any*/),
                                  (v2/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v6/*: any*/),
                      (v15/*: any*/),
                      (v33/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/)
                    ]
                  }
                ]
              },
              (v15/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "originalShowsQuery",
    "id": null,
    "text": "query originalShowsQuery(\n  $listCollectionId: ID!\n) {\n  listCollection(id: $listCollectionId) {\n    errors {\n      created\n      id\n      location\n      type\n    }\n    hasErrors\n    listCollection {\n      description\n      id\n      label\n      revision\n      lists {\n        __typename\n        ... on FixedList {\n          __typename\n          landingPageUrl\n          description\n          id\n          moreLikeThis\n          badges {\n            imageLink\n            link\n            previews {\n              count\n              edges {\n                cursor\n                preview {\n                  mediaAsset {\n                    id\n                    files {\n                      id\n                      name\n                      heightInPixels\n                      widthInPixels\n                      path\n                      status {\n                        kind\n                        id\n                      }\n                    }\n                    state {\n                      kind\n                      id\n                    }\n                    topLevelMediaType {\n                      kind\n                      id\n                    }\n                  }\n                  kind\n                  link\n                }\n              }\n            }\n            id\n          }\n          items {\n            pageInfo {\n              hasNextPage\n            }\n            edges {\n              cursor\n              listItem {\n                item {\n                  __typename\n                  ... on OriginalContentStory {\n                    __typename\n                    id\n                    revision\n                    landingPageUrl\n                    sourceList\n                    durationInSeconds\n                    description\n                    externalId\n                    subTitle\n                    title\n                    label\n                    link\n                    previews {\n                      count\n                      edges {\n                        cursor\n                        preview {\n                          mediaAsset {\n                            id\n                            files {\n                              id\n                              name\n                              heightInPixels\n                              widthInPixels\n                              path\n                              status {\n                                kind\n                                id\n                              }\n                            }\n                            state {\n                              kind\n                              id\n                            }\n                            topLevelMediaType {\n                              kind\n                              id\n                            }\n                          }\n                          kind\n                          link\n                        }\n                      }\n                    }\n                  }\n                  ... on Poster {\n                    __typename\n                    actionDescription\n                    actionTitle\n                    description\n                    permalink\n                    id\n                    previews {\n                      count\n                      edges {\n                        cursor\n                        preview {\n                          mediaAsset {\n                            id\n                            files {\n                              id\n                              name\n                              heightInPixels\n                              widthInPixels\n                              path\n                              status {\n                                kind\n                                id\n                              }\n                            }\n                            state {\n                              kind\n                              id\n                            }\n                            topLevelMediaType {\n                              kind\n                              id\n                            }\n                          }\n                          kind\n                          link\n                        }\n                      }\n                    }\n                    subTitle\n                    title\n                    revision\n                  }\n                  ... on Node {\n                    id\n                  }\n                  ... on SearchHit {\n                    id\n                  }\n                  ... on Tag {\n                    id\n                  }\n                }\n                question\n                id\n              }\n            }\n          }\n          label\n          name\n          previews {\n            count\n            edges {\n              cursor\n              preview {\n                mediaAsset {\n                  id\n                  files {\n                    id\n                    name\n                    heightInPixels\n                    widthInPixels\n                    path\n                    status {\n                      kind\n                      id\n                    }\n                  }\n                  state {\n                    kind\n                    id\n                  }\n                  topLevelMediaType {\n                    kind\n                    id\n                  }\n                }\n                kind\n                link\n              }\n            }\n          }\n          subTitle\n          title\n        }\n        ... on Node {\n          id\n        }\n      }\n      name\n      subTitle\n      title\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'ae820a4b87c092b937921fd8886d3649';
export default node;
